
import { Vue } from 'vue-class-component';
import Prop from '@common/decorators/Prop';

export default class Waiting extends Vue {
  @Prop({ default: 34 }) readonly size!: number;
}
